export default{
    props: {
        priority: {
            type: Number,
            default: null
        }
    },
};